module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/docker.62e5c713.svg";